import { SET_SPEARKER } from "./SectionTenAction";

const initialState = {
  speaker: [],
};

const sectionTenReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SPEARKER:
      return {
        ...state,
        speaker: action.payload,
      };

    default:
      return state;
  }
};

export default sectionTenReducer;
